import React from 'react';
import {FieldArray, Formik} from "formik";
import {FormActionButtons} from "components";
import {PregnancyModel} from "models";
import {Form, FormContent, MemberRows} from '../Forms.css'
import {PregnancyFormType, validationSchema} from './formUtils'
import {PregnancyFormRow} from './PregnancyFormRow'

interface PregnancyFormProps {
  defaultValues: PregnancyModel[];
  onBack: () => void;
  onSubmit: (values: PregnancyFormType) => void;
}

export const PregnancyForm = ({defaultValues, onSubmit, onBack}: PregnancyFormProps) => {
  return (
    <Formik
      initialValues={{pregnancy: defaultValues}}
      validationSchema={validationSchema}
      validateOnBlur={false}
      onSubmit={(values) => {
        onSubmit(values)
      }}
    >
      {({values, handleSubmit}) => (
        <Form onSubmit={handleSubmit}  autoComplete="off">
          <FieldArray name="pregnancy">
            {() => {
              return (
                <FormContent>
                  <MemberRows>
                    {values?.pregnancy?.map((_, index) => (
                      <PregnancyFormRow key={index} index={index} values={values}/>
                    ))}
                  </MemberRows>
                </FormContent>
              );
            }}
          </FieldArray>
          <FormActionButtons onBack={onBack}/>

        </Form>
      )}
    </Formik>
  );
};

